import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  DropDownSearchDraw,
  TableLayoutData,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Radio,
  Tabs,
  Tooltip,
  Table,
  Switch,
  Result,
  Checkbox,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { GlobalSet, StyledTab, Styled, PaperBlockList } from "../../pageStyled";
import {
  getPendingQuantityProductSizes,
  getProductDetails,
} from "../../../Services/productServices";
import { getUnitData } from '../../../Services/measurementService';
import {
  lengthUnit,
  weightUnit,
  currency_List,
  CoversionFactorUnitsToCM,
  CoversionFactorCMToUnits,
  conversionFactorUnitsToTonne,
  conversionFactorTonneToUnits

} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import { toFixedValue } from '../../../Utils/helper/helper';
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices.js";
import AlertContainer from "../../../Components/AlertBoxes/alertBox.jsx";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import OrdersTable from "./OrdersTable.jsx";

const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const Panes = Tabs.TabPane;

const runTypes = [
  { label: "All Sizes", value: "allSizes" },
  { label: "Selected Sizes", value: "selectedSizes" },
];
const grainTypeData = [{ label: "Long Grain", value: "long" }, { label: "Short Grain", value: "short" }];

const CreateNewSheetSolution = ({
  onClickCreateSolution,
  formValuesForStock,
  jobCardDetails,
  backButtonClicked,
  stockSizesArray,
  setStockSizesArray,
  createNewSolutionFormValuesForSizes,
  type,
  cutterType,
  solutionId,
  completeJCDetails,
  solutionType = "",
  ordersIdList,
  updateOrdersIdList,
  optimizePartition,
  minimizeOverfulfillment,
  onOptimizePartitionChange,
  onMinimizeOverfulfillmentChange,

  unselectedOrders,
  machineData,
  jobId,
  dynamicStock = [],
  dummy_orders = false,
  so_number =null
}) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const deckleWidthData = ["cm", "mm"];
  const [switchTooltip, setSwitchTooltip] = useState(true);
  const [tabKey, setTabKey] = useState();
  const [formValues, setFormValues] = useState({});
  const [stockSizes, setStockSizes] = useState(stockSizesArray || []);
  const [isAvailableQuantityUsed, setIsAvailableQuantityUsed] = useState(
    stockSizesArray?.length > 0
  );
  const [productData, setProductData] = useState({
    bulk: "",
    gsm: "",
  });
  const [plannedReels, setPlannedReels] = useState(0);
  const [errorText, setErrorText] = useState("");
  const [allowedQuantityerrorText, setAllowedQuantityerrorText] =
    useState(false);
  const [rerender, setRerender] = useState(false);
  const rotationData = [
    "Enabled", "Disabled"
  ];
  const [rotate, setRotate] = useState([]); 
  const [unitData, setUnitData] = useState();
  const [deckleUnit, setDeckleUnit] = useState();
  const [isDynamicStock, setIsDynamicStock] = useState(false);
  const [sizeErrorToastr, setSizeErrorToastr] = useState(false);
  const [errorToastr, setErrorToastr] = useState(false);
  const [orderIdList, setOrderIdList] = useState(
    Array.isArray(ordersIdList)
      ? ordersIdList
      : jobCardDetails?.group?.orders?.map((data) => data.order_id) || []
  );
  const [toleranceModal, setToleranceModal] = useState(false);
  const [globalTolerance, setGlobalTolerance] = useState({
    lower: 0,
    upper: 0,
  });
  const [showAlert, setShowAlert] = useState({
    isOrderChanged: false,
    isToleranceChanged: false,
    isGlobalToleranceChanged: false,
    isGlobalReelODChanged: false,
    isReelODChanged: false,
    toleranceLevel: "",
    isReelOrderChanged: false
  });
  const [isJobCardReelODEditModal, setJobCardReelODEditModal] = useState(false);
  const [globalReelOD,setGlobalReelOD] = useState({
    level:"Order",
    type:"",
    min_reel_od:0,
    max_reel_od:0,
    unit:"",
    selectedReelOD:[],
  })
  const [orderToastr, setOrderToastr] = useState(false);
  const didInitRef = useRef(false);
  const didApplyInitialSelectedSizesRef = useRef(false);
  const getSafeFixedValue = (value, fixed = 3) => {
    if (value === undefined || value === null || value === "") {
      return "";
    }
    const numericValue = parseFloat(value);
    if (Number.isNaN(numericValue)) {
      return "";
    }
    return toFixedValue(numericValue, fixed);
  };

  useEffect(() => {
    if (Array.isArray(ordersIdList)) {
      setOrderIdList(ordersIdList);
      return;
    }
    setOrderIdList(
      jobCardDetails?.group?.orders?.map((data) => data.order_id) || []
    );
  }, [ordersIdList, jobCardDetails]);


  useEffect(() => {
    if (!formValuesForStock) return;
    if (!formValuesForStock?.units) return;
    form.setFieldsValue({
      cutters: formValuesForStock?.maximum_cutters,
      min_deckle_length: formValuesForStock?.min_deckle_length,
      max_deckle_length: formValuesForStock?.max_deckle_length,
      min_width: formValuesForStock?.left_edge_trim,
      max_width: formValuesForStock?.right_edge_trim,
      effective_deckle_length: formValuesForStock?.effective_deckle_length,
      deckleLengthUnit: formValuesForStock?.units?.deckle_length_ub,
      widthUnit: formValuesForStock?.units?.right_edge_trim,
      partitionWeightUnit: formValuesForStock?.partitionWeightUnit,
      min_weight_per_partition: formValuesForStock?.min_weight_per_partition
    });
    setDeckleUnit(formValuesForStock?.units?.deckle_length_ub);
  }, [form, formValuesForStock, jobId, solutionId]);


  useEffect(() => {
    if (didInitRef.current) return;
    didInitRef.current = true;
    (async () => {
      const productCode = jobCardDetails?.group?.product?.code;
      const unitResponse = await getUnitData();
      setUnitData(unitResponse.data);
      form.setFieldsValue({
        cutters: formValuesForStock?.maximum_cutters,
        min_deckle_length: formValuesForStock?.min_deckle_length,
        max_deckle_length: formValuesForStock?.max_deckle_length,
        min_width: formValuesForStock?.left_edge_trim,
        max_width: formValuesForStock?.right_edge_trim,
        effective_deckle_length: formValuesForStock?.effective_deckle_length,
        deckleLengthUnit: formValuesForStock?.units?.deckle_length_ub,
        widthUnit: formValuesForStock?.units?.right_edge_trim,
        partitionWeightUnit: formValuesForStock?.partitionWeightUnit,
        min_weight_per_partition: formValuesForStock?.min_weight_per_partition
      });
      setDeckleUnit(formValuesForStock?.units?.deckle_length_ub);
     if (productCode) {
     await getProductDetails(productCode)
        .then((response) => {
          setProductData({
            bulk: `${response.data.bulk}`,
            gsm: `${response.data.gsm}`,
          });
        })
        .catch((error) => {
          console.log("Error in getting product specification list");
        });
      }
      if (stockSizes.length == 0) {
        let rotateData = [];
        if (productCode) {
        await getPendingQuantityProductSizes(productCode)
          .then((response) => {
            const stocks = response.data?.filter((data) => data.status === 'active' && data.type === 'sheet');
            const data = stocks?.map((item) => {
              let size = item.grain === "Long Grain" ? item.width : item.length;
              if (item.type === "reel") {
                size = item.width;
              }
              const processWeight = item.sheet_in_process.sheet_data?.reduce((n, { fulfilled_weight }) => n + fulfilled_weight, 0);
              const completedWeight = item.sheet_completed.sheet_data?.reduce((n, { fulfilled_weight }) => n + fulfilled_weight, 0);
              const productionWeight = item.sheet_in_production.sheet_data?.reduce((n, { fulfilled_weight }) => n + fulfilled_weight, 0);

              rotateData.push('Enabled');
              return {
                size: size,
                length: item.length,
                width: item.width,
                stockSizeId: item.id,
                stockSize:
                  item.type === "reel"
                    ? +item.width
                    : +item.width + ' ' + lengthUnit[item.units.width].displayName.toUpperCase() + " * " + +item.length + ' ' + lengthUnit[item.units.length].displayName.toUpperCase(),
                stockDefaultSize:
                  item.units.width === unitResponse.data.units_management.length.default ? '' : (item.type === "reel"
                    ? + (item.width * CoversionFactorUnitsToCM[item.units.width] * CoversionFactorCMToUnits[unitResponse.data.units_management.length.default]).toFixed(3) + " " + lengthUnit[unitResponse.data.units_management.length.default].displayName.toUpperCase()
                    : +(item.width * CoversionFactorUnitsToCM[item.units.width] * CoversionFactorCMToUnits[unitResponse.data.units_management.length.default]).toFixed(3) + " * " + +(item.length * CoversionFactorUnitsToCM[item.units.length] * CoversionFactorCMToUnits[unitResponse.data.units_management.length.default]).toFixed(3) + " " + lengthUnit[unitResponse.data.units_management.length.default].displayName.toUpperCase()),
                availableLimit: parseFloat(
                  item.quantity -
                  ((item.in_process + item.in_production + item.completed + processWeight + productionWeight + completedWeight) * conversionFactorTonneToUnits[item.units.quantity])
                ).toFixed(4),
                availableDefaultLimit: item.units.quantity === unitResponse.data.units_management.weight.default ? '' : (((parseFloat(
                  (
                    item.quantity -
                    ((item.in_process + item.in_production + item.completed + processWeight + productionWeight + completedWeight) * conversionFactorTonneToUnits[item.units.quantity])
                  )
                ) * conversionFactorUnitsToTonne[item.units.quantity] * conversionFactorTonneToUnits[unitResponse.data.units_management.weight.default])).toFixed(4) + " " + capitalize(weightUnit[unitResponse.data.units_management.weight.default].displayName)),
                isSelected:
                solutionType === "replan" &&
                jobCardDetails?.group?.orders?.some((data) => {
                  // Convert both to cm
                  
                  const itemWidthCM = parseFloat(item.width) * CoversionFactorUnitsToCM[item.units.width];
                    const dataWidthCM = parseFloat(data.width) * CoversionFactorUnitsToCM[data.units.width];

                  
                   const itemLengthCM = parseFloat(item.length) * CoversionFactorUnitsToCM[item.units.length];
                  const dataLengthCM = parseFloat(data.length) * CoversionFactorUnitsToCM[data.units.length];
                    // For sheet: compare both
                    return (
                      Math.abs(itemLengthCM - dataLengthCM) < 0.01 &&
                      Math.abs(itemWidthCM - dataWidthCM) < 0.01
                    );
                  
                }),                
                plannedWeightError: "",
                allowedQuantityError: "",
                grain: item.grain,
                units: item.units,
                availableUnit: item.units.quantity,
                allowedQuantity: parseFloat(
                  item.quantity -
                  (item.in_process +
                    item.in_production +
                    item.completed +
                    processWeight +
                    productionWeight +
                    completedWeight) *
                  conversionFactorTonneToUnits[item.units.quantity]
                ).toFixed(3),
                isGrainChanged: item.rotated ? item.rotated : false,
              };
            });
            const stocksData = data?.filter((data) => data.availableLimit > 0);
            const existingDynamicStocks = stockSizes.filter(
              (stock) => stock.isNew || stock.isRequired
            );

            if (solutionType == "replan") {
              if (dynamicStock.length) {
                const allDynamicStocks = [
                  ...existingDynamicStocks,
                  ...dynamicStock,
                ];
                setStockSizes([...stocksData, ...allDynamicStocks]);
              } else {
                setStockSizes([...stocksData, ...existingDynamicStocks]);
              }
            } else if (solutionId == "1" || solutionId == "2") {
              let data =
                solutionId == "1"
                  ? jobCardDetails?.solution_1?.data?.orders
                 : jobCardDetails?.solution_2?.data?.orders;
              const dynamicStockData = data
                ?.filter((order) => {
                  return order.creation_type === "dynamic" || order.creation_type === "required";
                })
                .map((item) => {
                  const quantityUnit = item?.units?.allowed_quantity || item?.units?.planned_weight || item?.units?.fulfilled_weight || item?.units?.quantity || unitResponse.data.units_management.weight.default;
                  const lengthUnitValue = item?.units?.length;
                  const widthUnitValue = item?.units?.breadth || item?.units?.width;
                  const calculatedSheets =
                    (parseFloat(item?.requirement * conversionFactorUnitsToTonne[quantityUnit]) * 10000 * 1000000) /
                    (parseFloat(productData.gsm) *
                      parseFloat(item?.length * CoversionFactorUnitsToCM[lengthUnitValue]) *
                      parseFloat(item?.width * CoversionFactorUnitsToCM[widthUnitValue]));
                  return {
                    allowedQuantity: item?.requirement,
                    availableLimit: item?.requirement,
                    availableUnit: quantityUnit,
                    sheets: item?.sheets ?? item?.sheet_requirement ?? (isNaN(calculatedSheets) ? 0 : Math.floor(calculatedSheets)),
                    length: item?.length,
                    width: item?.width,
                  stockSize:
                  item.type === "reel"
                    ? +item.width
                    : +item.width + ' ' + lengthUnit[widthUnitValue].displayName.toUpperCase() + " * " + +item.length + ' ' + lengthUnit[lengthUnitValue].displayName.toUpperCase(),
                                   isSelected: true,
                    ...(item.creation_type === "dynamic" && { isNew: true }),
                    ...(item.creation_type === "required" && {
                      isRequired: true,
                      weight_lb: item.requirement_lb,
                      weight_ub: item.requirement_ub,
                      priority_stock: item.priority_stock,
                    }),
                    isEdit: false,
                    isGrainChanged: item.rotated ? item.rotated : false,
                                    grain: item.grain,
                    units: {
                      ...item.units,
                      quantity: quantityUnit,
                      width: widthUnitValue,
                      length: lengthUnitValue,
                      weight_lb: item?.units?.weight_lb || item?.units?.requirement_lb,
                      weight_ub: item?.units?.weight_ub || item?.units?.requirement_ub,
                    },
                  };
                });

              const allDynamicStocks = [
                ...existingDynamicStocks,
                ...(dynamicStockData || []),
              ];
              if (allDynamicStocks.length) {
                setStockSizes([...stocksData, ...allDynamicStocks]);
              } else {
                setStockSizes([...stocksData, ...existingDynamicStocks]);
              }
            } else {
              setStockSizes([...stocksData, ...existingDynamicStocks]);
            }
            setRotate(rotateData);
          })
          .catch((error) => { });
        }
      }
      else {
        let rotateData = [];
        rotateData.push('Enabled');
        setRotate(rotateData);

      }
      let deckleMangtSettings = await getWorkflowSettings("deckle_management");

      setIsDynamicStock(deckleMangtSettings?.data?.dynamic_stocks?.value);

    })();
  }, []);

  useEffect(() => {
    if (didApplyInitialSelectedSizesRef.current) return;
    if (!stockSizes?.length) return;
    if (!createNewSolutionFormValuesForSizes?.selectedSizes?.length) return;

    didApplyInitialSelectedSizesRef.current = true;
    stockSizes.forEach((stockSize, index) => {
      const sizeDetails =
        createNewSolutionFormValuesForSizes?.selectedSizes?.filter(
          (size) => size.stockSizeId == stockSize.stockSizeId
        );
      if (sizeDetails && sizeDetails.length > 0) {
        onAllowedQuantityChange(
          sizeDetails[0].length,
          sizeDetails[0].width,
          sizeDetails[0].allowedQuantity,
          index
        );
      }
    });
  }, [stockSizes, createNewSolutionFormValuesForSizes]);

  useEffect(() => {
    if (rerender) {
      setRerender(false);
    }
  }, [rerender]);

  const onClickCreateSolutionButton = async () => {
    await setUpdatedFormValues();
    form.submit();
  };

  const setUpdatedFormValues = () => {
    let updatedFormValues = formValues;
    updatedFormValues["status"] = form.getFieldValue("status");
    updatedFormValues["selectedSizes"] = [];
    let temp = stockSizes.filter((item) => item.isSelected == true);
    temp.forEach((item) => {
      var index = stockSizes.findIndex(
        (obj) => obj.stockSizeId == item.stockSizeId
      );

      let selectedSizes = {
        type: "sheet",
        stockSizeId: item.stockSizeId,
        stockSize: item.stockSize,
        allowedQuantity: parseFloat(item.allowedQuantity),
        sheets: item.sheets,
        plannedWeight: parseFloat(item.allowedQuantity),
        rotated: stockSizes[index].isGrainChanged,
        grain: stockSizes[index].grain,
        length: item.length,
        mixed_grain: false,
        width: item.width,
        ...(item.isRequired && {
          weight_lb: parseFloat(item.weight_lb),
          weight_ub: parseFloat(item.weight_ub),
          requirement_lb: item.lowerSheets,
          requirement_ub: item.upperSheets,
          priority_stock: item.priority_stock ? true : false,
        }),
        units: {
          length: item.units.length,
          breadth: item.units.width,
          width: item.units.width,
          planned_weight: item.units.quantity,
          allowed_quantity: item.units.quantity,
          ...(item.isRequired && {
            weight_lb: item.units.weight_lb,
            weight_ub: item.units.weight_ub,
          }),
        },
        creation_type: item.isNew ? "dynamic" : item.isRequired ? 'required' : "static",

      };
      updatedFormValues.selectedSizes.push(selectedSizes);
    });
    updatedFormValues["minDeckleLength"] =
      form.getFieldValue("min_deckle_length");
    updatedFormValues["maxDeckleLength"] =
      form.getFieldValue("max_deckle_length");
    updatedFormValues["deckleLengthUnit"] =
      form.getFieldValue("deckleLengthUnit");
    updatedFormValues["minWidth"] = form.getFieldValue("min_width");
    updatedFormValues["maxWidth"] = form.getFieldValue("max_width");
    updatedFormValues["widthUnit"] = form.getFieldValue("widthUnit");
    updatedFormValues["effectiveDeckleLength"] = form.getFieldValue(
      "effective_deckle_length"
    );
    updatedFormValues["cutters"] = form.getFieldValue("cutters");

    updatedFormValues["min_weight_per_partition"] = form.getFieldValue(
      "min_weight_per_partition"
    );
    updatedFormValues["partitionWeightUnit"] = form.getFieldValue(
      "partitionWeightUnit"
    );


    setFormValues(updatedFormValues);
  };

  const handleTabChange = async (key) => {
    await setUpdatedFormValues();
    setTabKey(key);
  };

  const onFinish = async (e) => {
    // let updatedFormValues = formValues;
    // if (tabKey == 1) {
    //   updatedFormValues['status'] = e.status;
    //   updatedFormValues['selectedSizes'] = [];
    //   let temp = stockSizes.filter(item => item.isSelected == true);
    //   temp.forEach(item => {
    //     var index = stockSizes.findIndex((obj) => obj.stockSize == item.stockSize);

    //     let selectedSizes = {
    //       stockSizeId: stockSizes[index].stockSizeId,
    //       stockSize: item.stockSize,
    //       allowedQuantity: e['allowed-quantity' + index],
    //       reels: e['reels' + index],
    //       plannedWeight: e['planned-weight' + index]
    //     }
    //     updatedFormValues.selectedSizes.push(selectedSizes);
    //   })
    //   setFormValues(updatedFormValues);
    // }
    // else {
    //   updatedFormValues['minDeckleLength'] = e.min_deckle_length;
    //   updatedFormValues['maxDeckleLength'] = e.max_deckle_length;
    //   updatedFormValues['deckleLengthUnit'] = e.deckleLengthUnit;
    //   updatedFormValues['minWidth'] = e.min_width;
    //   updatedFormValues['maxWidth'] = e.max_width;
    //   updatedFormValues['widthUnit'] = e.widthUnit;
    //   updatedFormValues['effectiveDeckleLength'] = e.effective_deckle_length;
    //   updatedFormValues['cutters'] = e.cutters;
    // }
    // setFormValues(updatedFormValues);
    // let erroredStocks = stockSizes.filter(
    //   (stockSize) =>
    //     stockSize.plannedWeightError != "" ||
    //     stockSize.allowedQuantityError != ""
    // );
    // if (erroredStocks && erroredStocks.length == 0) {
    setStockSizesArray(stockSizes);
    const newSelectedSizes = formValues.selectedSizes.map((value) => {

      return {
        ...value,
        plannedWeight: value.allowedQuantity,
      };

    });
    if (formValues.selectedSizes.length)
      formValues.selectedSizes = newSelectedSizes;
     if (orderIdList && orderIdList.length) onClickCreateSolution(formValues);
    else {
      setOrderToastr(true);
      setTimeout(() => {
        setOrderToastr(false);
      }, 3000);
    } //}
    // }
  };

  const handleRunTypeChange = (e) => {
    if (e.target.value === "allSizes") {
      // Use .map to create a new array with updated properties
      const newStockSizes = stockSizes.map((stockSize, index) => {
        const sizeDetails = createNewSolutionFormValuesForSizes?.selectedSizes?.filter(
          (size) => size.stockSizeId === stockSize.stockSizeId
        );

        let allowedQuantity;
        if (sizeDetails && sizeDetails.length > 0) {
          allowedQuantity = sizeDetails[0].allowedQuantity;
        } else {
          allowedQuantity = stockSize.availableLimit;
        }

        // Trigger calculations for each item
        const value =
      (parseFloat(stockSize.allowedQuantity * conversionFactorUnitsToTonne[stockSize.units.quantity]) * 10000 * 1000000) /
      (parseFloat(productData.gsm) *
        parseFloat(stockSize.length * CoversionFactorUnitsToCM[stockSize.units.length]) *
        parseFloat(stockSize.width * CoversionFactorUnitsToCM[stockSize.units.width]));

    const plannedSheetsValue = isNaN(value) ? 0 : Math.floor(value);
        

        // Return a new object for each item
        return { ...stockSize, isSelected: true,sheets: plannedSheetsValue};
      });
      setStockSizes(newStockSizes);
    } else {
      // This part was already immutable, but using .map is clearer
      setStockSizes((prevStocks) =>
        prevStocks.map((stock) => ({ ...stock, isSelected: false }))
      );
    }
  };

  const handleSwitchChange = (index) => {
    setSwitchTooltip(!switchTooltip);
    const stockToUpdate = stockSizes[index];
    if (!stockToUpdate) return;
    const isEnablingStock = !stockToUpdate.isSelected;
    const selectedAllowedQuantity = stockToUpdate.allowedQuantity ?? stockToUpdate.availableLimit;

    if (isEnablingStock) {
      onAllowedQuantityChange(
        stockToUpdate.length,
        stockToUpdate.width,
        selectedAllowedQuantity,
        index
      );

      form.setFieldsValue({ [`rotated${index}`]: "Enabled" });
      form.setFieldsValue({
        [`allowed-quantity${index}`]: getSafeFixedValue(
          selectedAllowedQuantity,
          3
        ),
      });
    }

    // Use .map() for an immutable update
    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) =>
        i === index ? { ...stock, isSelected: !stock.isSelected } : stock
      )
    );
  };

  const changeDeckleLength = () => {
    setDeckleUnit(form.getFieldValue("deckleLengthUnit"));
    const result =
      (form.getFieldValue("max_deckle_length") * CoversionFactorUnitsToCM[form.getFieldValue("deckleLengthUnit")]) -
      (form.getFieldValue("min_width") * CoversionFactorUnitsToCM[form.getFieldValue("widthUnit")]) -
      (form.getFieldValue("max_width") * CoversionFactorUnitsToCM[form.getFieldValue("widthUnit")])

    form.setFieldsValue({ effective_deckle_length: toFixedValue(result * CoversionFactorCMToUnits[form.getFieldValue("deckleLengthUnit")], 3) });
    // if (result < 0) {
    //   form.setFieldsValue({
    //     min_width: "",
    //     max_width: "",
    //     effective_deckle_length: "",
    //   });
    //   setShowError({
    //     error: true,
    //     message: `Total edge trim cannot be greater than deckle width`,
    //   });
    // } else {
    //   setShowError({
    //     error: false,
    //   });
    //   form.setFieldsValue({ effective_deckle_length: result.toFixed(2) });
    // }
  };

  const onAllowedQuantityChange = (length, width, weight, index) => {
    // Use a functional update to get the latest state
    // setStockSizes((prevStocks) =>
    //   prevStocks.map((stock, i) => {
    //     if (i === index) {
    //       const newStock = { ...stock }; // Create a new object
    //       if (parseFloat(weight) > parseFloat(stock.availableLimit)) {
    //         newStock.allowedQuantityError =
    //           "Allowed Qty should be less than or equal to Available Limit";
    //       } else {
    //         newStock.allowedQuantityError = "";
    //       }
    //       return newStock;
    //     }
    //     return stock;
    //   })
    // );

    // Check for form validation errors before calculating
    const errors = form.getFieldsError([
      `allowed-quantity${index}`,
      `length${index}`,
      `width${index}`,
    ]);
    const hasError = errors.some(field => field.errors.length > 0);

    if ((!hasError || !stockSizes[index].isEdit) && length && width && weight) {
      calculatePlannedSheets(length, width, weight, index);
    }
  };

  const calculatePlannedSheets = (length, width, weight, index) => {
    const stockItem = stockSizes[index];
    if (!stockItem) return; // Guard against race conditions

    const value =
      (parseFloat(weight * conversionFactorUnitsToTonne[stockItem.units.quantity]) * 10000 * 1000000) /
      (parseFloat(productData.gsm) *
        parseFloat(length * CoversionFactorUnitsToCM[stockItem.units.length]) *
        parseFloat(width * CoversionFactorUnitsToCM[stockItem.units.width]));

    const plannedSheetsValue = isNaN(value) ? 0 : Math.floor(value);


    // Use .map() for an immutable update
   setStockSizes((prevStocks) => {
    const prevValue = prevStocks[index]?.sheets;
    if (prevValue === plannedSheetsValue) return prevStocks; // no change → skip

    return prevStocks.map((stock, i) =>
      i === index ? { ...stock, sheets: plannedSheetsValue } : stock
    );
  });

  };

  const calculatePlannedWeight = (length, width, sheets, index) => {
    const stockItem = stockSizes[index];
    if (!stockItem) return; // Guard clause

    const value =
      (parseFloat(length * CoversionFactorUnitsToCM[stockItem.units.length]) *
        parseFloat(width * CoversionFactorUnitsToCM[stockItem.units.width]) *
        parseFloat(sheets) *
        parseFloat(productData.gsm)) /
      (10000 * 1000000);

    const plannedWeightValue = isNaN(value) ? '' : toFixedValue(value * conversionFactorTonneToUnits[stockItem.units.quantity], 3);
    form.setFieldsValue({ [`planned-weight${index}`]: plannedWeightValue });

    // Use a functional update with .map()
    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) => {
        if (i === index) {
          const newStock = { ...stock };
          if (parseFloat(stock.availableLimit) < plannedWeightValue) {
            newStock.plannedWeightError =
              "Planned Weight should be less than or equal to Available Limit";
          } else {
            newStock.plannedWeightError = "";
          }
          return newStock;
        }
        return stock;
      })
    );
    setRerender(true); // You may not need this anymore, but it doesn't hurt
  };

  const handleRotate = (e, index) => {
    let data = rotate;
    data[index] = e;
    setRotate(data);
  }

  const handleEdit = (index) => {
    setSwitchTooltip(!switchTooltip);
    const stockToUpdate = stockSizes[index];

    // onAllowedQuantityChange(
    //   stockToUpdate.length,
    //   stockToUpdate.width,
    //   stockToUpdate.allowedQuantity,
    //   index,
    // );

    // Use .map() to toggle the isEdit flag
    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) =>
        i === index ? { ...stock, isEdit: !stock.isEdit } : stock
      )
    );
  };

  const onSaveChages = async (index) => {
    try {
      // 1. Update validation to check for length and width
      const fieldsToValidate = [
        `length${index}`,
        `width${index}`,
        `grain${index}`,
        `allowed-quantity${index}`,
      ];

      if (stockSizes[index].isRequired) {
        fieldsToValidate.push(`lower_limit${index}`, `upper_limit${index}`);
      }

      await form.validateFields(fieldsToValidate);

      // 2. Update duplicate check logic for length and width
      const currentLengthCM =
        parseFloat(form.getFieldValue(`length${index}`)) *
        CoversionFactorUnitsToCM[form.getFieldValue(`length_unit${index}`)];

      const currentWidthCM =
        parseFloat(form.getFieldValue(`width${index}`)) *
        CoversionFactorUnitsToCM[form.getFieldValue(`width_unit${index}`)];

      const isDuplicate = stockSizes.some((data, idx) => {
        if (idx === index ) {
          // Skip self-comparison and existing (non-editable) stocks
          return false;
        }
        const existingLengthCM = parseFloat(data.length) * CoversionFactorUnitsToCM[data.units.length];
        const existingWidthCM = parseFloat(data.width) * CoversionFactorUnitsToCM[data.units.width];

        // Check for both (L x W)duplicates
        return (
          (existingLengthCM === currentLengthCM && existingWidthCM === currentWidthCM)
        );
      });

      if (isDuplicate) {
        setSizeErrorToastr(true);
        setTimeout(() => {
          setSizeErrorToastr(false);
        }, 3000);
        return; // Prevent saving if a duplicate is found
      }

      // Use .map() to update the state with all the new values
      setStockSizes((prevStocks) =>
        prevStocks.map((stock, i) => {
          if (i === index) {
            // Create a new object with all the updated fields
            return {
              ...stock,
              allowedQuantity: form.getFieldValue(`allowed-quantity${index}`),
              stockSize: form.getFieldValue(`width${index}`) + ' ' + lengthUnit[form.getFieldValue(`width_unit${index}`)].displayName.toUpperCase() + " * " + form.getFieldValue(`length${index}`) + ' ' + lengthUnit[form.getFieldValue(`length_unit${index}`)].displayName.toUpperCase(),              length: form.getFieldValue(`length${index}`),
              width: form.getFieldValue(`width${index}`),
              grain: form.getFieldValue(`grain${index}`),
              weight_lb: form.getFieldValue(`lower_limit${index}`),
              weight_ub: form.getFieldValue(`upper_limit${index}`),
              units: {
                ...stock.units,
                quantity: form.getFieldValue(`allowed-quantity_unit${index}`),
                length: form.getFieldValue(`length_unit${index}`),
                width: form.getFieldValue(`width_unit${index}`),
                weight_lb: form.getFieldValue(`lower_unit${index}`),
                weight_ub: form.getFieldValue(`upper_unit${index}`),
              },
              isEdit: false, // Flip the edit flag
            };
          }
          return stock;
        })
      );
    } catch (err) {
      // ... (error handling is fine)
    }
  };

  const onDiscardChanges = (index) => {
  let updatedStocks = [...stockSizes];

  // CASE 1: Remove if it's new or required
  if (stockSizes[index].isNew || stockSizes[index].isRequired) {
    updatedStocks.splice(index, 1);

    const total = updatedStocks.length + 1;
    for (let i = index; i < total; i++) {
      const next = i + 1;
      const keys = [
        "size",
        "length",
        "width",
        "length_unit",
        "width_unit",
        "grain",
        "allowed-quantity",
        "size_unit",
        "allowed-quantity_unit",
        "lower_limit",
        "lower_unit",
        "upper_limit",
        "upper_unit",
      ];

      keys.forEach((key) => {
        const nextKey = `${key}${next}`;
        const currKey = `${key}${i}`;
        const nextValue = form.getFieldValue(nextKey);
        form.setFieldsValue({ [currKey]: nextValue ?? undefined });
      });
    }

    // Clear the last form group fields
    const lastIndex = updatedStocks.length;
    [
      "size",
      "length",
      "width",
      "length_unit",
      "width_unit",
      "grain",
      "allowed-quantity",
      "size_unit",
      "allowed-quantity_unit",
      "lower_limit",
      "lower_unit",
      "upper_limit",
      "upper_unit",
    ].forEach((key) => {
      form.setFieldsValue({ [`${key}${lastIndex}`]: undefined });
    });

    setStockSizes(updatedStocks);
  }

  // CASE 2: Just discard edits
  else {
    updatedStocks[index].isEdit = false;
    const stock = updatedStocks[index];

    const fieldMap = {
      [`size${index}`]: stock.stockSize,
      [`length${index}`]: stock.length,
      [`width${index}`]: stock.width,
      [`length_unit${index}`]: stock.units.length,
      [`width_unit${index}`]: stock.units.width,
      [`grain${index}`]: stock.grain,
      [`allowed-quantity${index}`]: stock.allowedQuantity,
      [`size_unit${index}`]: stock.units.width,
      [`allowed-quantity_unit${index}`]: stock.units.quantity,
    };

    if (stock.isRequired) {
      fieldMap[`lower_limit${index}`] = stock.weight_lb;
      fieldMap[`lower_unit${index}`] = stock.units.weight_lb;
      fieldMap[`upper_limit${index}`] = stock.weight_ub;
      fieldMap[`upper_unit${index}`] = stock.units.weight_ub;
    }

    form.setFieldsValue(fieldMap);
    setStockSizes(updatedStocks);
  }
};

  const onAddStock = () => {
    let updatedStocks = [...stockSizes];
    let stock = {
      grain: undefined,
      allowedQuantity: "",
      stockSize: "",
      length: "",
      width: "",
      stockSizeId: null,
      isSelected: true,
      isNew: true,
      isEdit: true,
      units: {
        quantity: unitData.units_management.weight.default,
        width: unitData.units_management.length.default,
        length: unitData.units_management.length.default,
      },
      isGrainChanged: false,
      rotate: false,
    };
    updatedStocks.push(stock);

    setStockSizes([...updatedStocks]);
  };

  const onAddRequiredStock = () => {
    let updatedStocks = [...stockSizes];
    let stock = {
      grain: undefined,
      allowedQuantity: "",
      stockSize: "",
      isSelected: true,
      isRequired: true,
      isEdit: true,
      length: "",
      width: "",
      stockSizeId: null,
      weight_lb: '',
      weight_ub: '',
      priority_stock: false,
      units: {
        quantity: unitData.units_management.weight.default,
        width: unitData.units_management.length.default,
        length: unitData.units_management.length.default,
        weight_lb: unitData.units_management.weight.default,
        weight_ub: unitData.units_management.weight.default,
      },
      isGrainChanged: false,
      rotate: false,
    };
    updatedStocks.push(stock);

    setStockSizes([...updatedStocks]);
  };

  const changePriority = (e, index) => {
    const { checked } = e.target;

    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) =>
        i === index ? { ...stock, priority_stock: checked } : stock
      )
    );
  };



  const changeGrain = (e, index) => {
    const { checked } = e.target;

    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) =>
        i === index ? { ...stock, isGrainChanged: checked } : stock
      )
    );
  };


  const calculateUpperLimitSheets = (length, width, upperWeight, index) => {
    // Proceed only if essential values are present and valid
    const errors = form.getFieldsError([
      `length${index}`,
      `width${index}`,
      `upper_limit${index}`,
    ]);

    const hasError = errors.some(field => field.errors.length > 0);

    if (
      !upperWeight ||
      !length ||
      !width ||
      !productData.gsm ||
      !stockSizes[index] ||
      hasError
    ) {
      // Clear the value if inputs are invalid
      setStockSizes((prevStocks) => {
        const newStocks = [...prevStocks];
        if (newStocks[index]) {
          newStocks[index].upperSheets = 0;
        }
        return newStocks;
      });
      return;
    }


    // Get the units for calculation from the form and state
    const upperWeightUnit = form.getFieldValue(`upper_unit${index}`);
    const lengthUnit = form.getFieldValue(`length_unit${index}`);
    const widthUnit = form.getFieldValue(`width_unit${index}`);

    // Calculate the number of sheets
    const sheetCount =
      (parseFloat(upperWeight * conversionFactorUnitsToTonne[upperWeightUnit]) * 10000 * 1000000) /
      (parseFloat(productData.gsm) *
        parseFloat(length * CoversionFactorUnitsToCM[lengthUnit]) *
        parseFloat(width * CoversionFactorUnitsToCM[widthUnit]));

    const calculatedSheets = isNaN(sheetCount) ? 0 : Math.floor(sheetCount);

    // Update the stockSizes array with the new 'upperSheets' value
    setStockSizes((prevStocks) => {
      const newStocks = [...prevStocks];
      newStocks[index] = {
        ...newStocks[index],
        upperSheets: calculatedSheets,
      };
      return newStocks;
    });
  };

  const calculateLowerLimitSheets = (length, width, lowerWeight, index) => {
    // Proceed only if essential values are present and valid
    const errors = form.getFieldsError([
      `length${index}`,
      `width${index}`,
      `lower_limit${index}`,
    ]);

    const hasError = errors.some(field => field.errors.length > 0);

    if (
      !lowerWeight ||
      !length ||
      !width ||
      !productData.gsm ||
      !stockSizes[index] ||
      hasError
    ) {
      // Clear the value if inputs are invalid
      setStockSizes((prevStocks) => {
        const newStocks = [...prevStocks];
        if (newStocks[index]) {
          newStocks[index].lowerSheets = 0;
        }
        return newStocks;
      });
      return;
    }

    // Get the units for calculation from the form and state
    const lowerWeightUnit = form.getFieldValue(`lower_unit${index}`);
    const lengthUnit = form.getFieldValue(`length_unit${index}`);
    const widthUnit = form.getFieldValue(`width_unit${index}`);
    // Calculate the number of sheets
    const sheetCount =
      (parseFloat(lowerWeight * conversionFactorUnitsToTonne[lowerWeightUnit]) * 10000 * 1000000) /
      (parseFloat(productData.gsm) *
        parseFloat(length * CoversionFactorUnitsToCM[lengthUnit]) *
        parseFloat(width * CoversionFactorUnitsToCM[widthUnit]));

    const calculatedSheets = isNaN(sheetCount) ? 0 : Math.floor(sheetCount);

    // Update the stockSizes array with the new 'lowerSheets' value
    setStockSizes((prevStocks) => {
      const newStocks = [...prevStocks];
      newStocks[index] = {
        ...newStocks[index],
        lowerSheets: calculatedSheets,
      };
      return newStocks;
    });
  };

const onClickSetToleranceButton = () => {
    if(orderIdList.length!=0)
      setToleranceModal(!toleranceModal);
    else
    {  
      setOrderToastr(true);
      setTimeout(()=>setOrderToastr(false),2300);
    }
  };

  return unitData && deckleUnit ? (
    <RightLayoutContainer id="right-layout-container">
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          onBack={() => backButtonClicked()}
          title={
            solutionType == "replan" ? "Replan Job Card" : "Create new solution"
          }
          extra={[
            <div
              style={{
                display: "flex",
                alignItems: "start",
                justifyContent: "center",
              }}
            >
              {tabKey === "3" && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    {/* <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={onClickSetToleranceButton}
                    >
                      <Iconmoon icon="set" size={15} color="#EA655B" />
                      Set Tolerance
                    </Button> */}
                    {showAlert.isGlobalToleranceChanged &&<span
                      className="failedJobMessage"
                      style={{
                        marginTop:"0px"
                      }}
                    >
                      <div style={{display: "flex", alignItems: "center",gap:"5px"}}>
                        {  showAlert.isGlobalToleranceChanged &&
                          (showAlert.isToleranceChanged ||
                            showAlert.isOrderChanged) && showAlert.toleranceLevel === "JobCard" && (
                            <Tooltip
                              placement="bottomRight"
                              title={
                                "Tolerance applied earlier do not apply to the newly selected/edited orders. Click 'Set Tolerance' again to update."
                              }
                            >
                              <Iconmoon
                                icon="warning-icon"
                                size={14}
                                color="#EA655B"
                              />
                              </Tooltip>
                          )}
                       {globalTolerance.lower!==0 && globalTolerance.upper!==0 && showAlert.toleranceLevel === "JobCard" &&<div> 
                        LB <strong>{globalTolerance.lower}%</strong>
                        {"    "}
                        <span style={{paddingLeft:"5px"}}/>
                        UB <strong>{globalTolerance.upper}%</strong>
                        </div>}
                      </div>
                    </span>}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    {globalReelOD.level == "JobCard" && 
                      <span className="failedJobMessage" style={{marginTop:"0px",display:"flex",alignItems:"center",gap:"3px"}}>
                        {showAlert.isGlobalReelODChanged &&
                          (showAlert.isReelODChanged ||
                            showAlert.isReelOrderChanged) && 
                          <Tooltip
                            placement="bottomRight"
                            title={
                              "Reel dimensions applied earlier do not apply to the newly selected/edited orders. Click 'Set Reel OD' again to update."
                            }
                          >
                            <Iconmoon
                              icon="warning-icon"
                              size={14}
                              color="#EA655B"
                            />
                          </Tooltip>
                        }
                        {globalReelOD.type == "Constant" 
                        ?<span>
                          {globalReelOD.selectedReelOD[0]}
                          {globalReelOD.selectedReelOD.length > 1 &&
                            <Tooltip
                              placement="bottomRight"
                              title={
                                ()=>{
                                  let text="";
                                  globalReelOD.selectedReelOD.slice(1).forEach(item=>text=text+" "+item);
                                  return text;
                                }
                              }
                            >
                              <span>{`  & ${globalReelOD.selectedReelOD.length-1}more`}</span>
                            </Tooltip>
                          }
                        </span>
                        :<span>{`${globalReelOD.min_reel_od} ${globalReelOD.unit} - ${globalReelOD.max_reel_od} ${globalReelOD.unit}`}</span>}
                      </span>
                    }
                  </div>
                </>
              )}
              <Button
                key="3"
                className="themeBtn"
                onClick={onClickCreateSolutionButton}
              >
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Create Solution
              </Button>
            </div>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <Form
        form={form}
        name="basic"
        autoComplete="off"
        className="haberLogin"
        onFinish={onFinish}
        onFinishFailed={(error) => {
          console.log("Form Error", error);
        }}
        initialValues={{
          remember: true,
        }}
      >
        <div className="groupedTabed">
          <StyledTab>
            <Tabs
              defaultActiveKey="1"
              onChange={handleTabChange}
              style={{ padding: "0px 0px 20px 0px" }}
            >
              <Panes tab="Stock Size" key="1">
                <DetailFields>
                  <HaberForm>
                    <>
                      <div className="groupDetailWrap">
                        <Row gutter={[16, 16]} className="groupForm">
                          <Col span={14}>
                            <div
                              className="boxFieldTitle"
                              style={{ marginTop: "20px" }}
                            >
                              <label>Select Run Type</label>
                              <p>
                                Select if you would like to include specific sizes
                                quantity or let the system decide the optimum size
                                and quantity
                              </p>
                            </div>
                          </Col>
                          <Col span={10}>
                            <div
                              className="boxFormType switchRadio extraWidth"
                              style={{
                                justifyContent: "flex-end",
                                display: "flex",
                                marginTop: "20px",
                              }}
                            >
                              <Form.Item
                                name="status"
                                className=""
                                initialValue={
                                  createNewSolutionFormValuesForSizes?.status
                                    ? createNewSolutionFormValuesForSizes?.status
                                    : "selectedSizes"
                                }
                              >
                                <Radio.Group
                                  options={runTypes}
                                  onChange={handleRunTypeChange}
                                  optionType="button"
                                  buttonStyle="solid"
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>

                        <Row gutter={[16, 16]} className="groupForm">
                          <Col span={24} className="blockBreak centerAlign">
                            <PaperBlockList>
                              <Row style={{ width: "100%" }}>
                                <Col span={10}>
                                  <div
                                    className="boxFieldTitle removeStar"
                                    style={{ marginTop: "20px" }}
                                  >
                                    <label>Select Stock Sizes</label>
                                    <p>
                                      Select the sizes and quantity to process
                                      with orders
                                    </p>
                                  </div>
                                </Col>
                                <Col span={14}>
                                  <>
                                    {stockSizes.map((stockSize, index) => {
                                      const isExistingStock = !stockSize.isNew && !stockSize.isRequired;
                                      const isNewStock = stockSize.isNew;
                                      const isRequiredStock = stockSize.isRequired;

                                      return (
                                        <Row className="centerAlign" key={index}>
                                          <Row style={{ width: "100%" }}>
                                            <Col span={18}>
                                              <div className=" removeStar">
                                                <label>
                                                  {stockSize.stockSize ? (
                                                    <>
                                                      {stockSize.stockSize}
                                                      {stockSize.grain && (
                                                        <span
                                                          style={{
                                                            fontSize: "11px",
                                                            fontFamily: "var(--sf-pro-display-m)",
                                                            color: stockSize.grain === "long" ? "green" : "red",
                                                            lineHeight: "16px",
                                                            backgroundColor:
                                                              stockSize.grain === "long" ? "#e6f4ea" : "#fdecea",
                                                            borderRadius: "10px",
                                                            padding: "1px 8px",
                                                            marginLeft: "10px",
                                                            fontStyle: "unset",
                                                          }}
                                                        >
                                                          {stockSize.grain === 'long' ? 'LONG' : 'SHORT'}
                                                        </span>
                                                      )}
                                                    </>
                                                  ) : isRequiredStock ? "New Required Sheet Stock" : "New Sheet Stock"}
                                                </label>
                                                {!stockSize.isEdit && (
                                                  <p>
                                                    {isExistingStock && (
                                                      <span
                                                        style={{
                                                          width: "180px",
                                                          display: "inline-block",
                                                        }}
                                                      >
                                                        Available Limit :{" "}
                                                        {stockSize.availableLimit +
                                                          " " +
                                                          capitalize(
                                                            weightUnit[
                                                              stockSize?.availableUnit
                                                            ]?.displayName
                                                          ) +
                                                          (stockSize.availableDefaultLimit
                                                            ? " ( " +
                                                            stockSize.availableDefaultLimit +
                                                            " )"
                                                            : "")}
                                                      </span>
                                                    )}
                                                    <span>
                                                      Allowed Limit :{" "}
                                                      {stockSize.allowedQuantity +
                                                        " " +
                                                        capitalize(
                                                          weightUnit[
                                                            stockSize.units
                                                              .quantity
                                                          ].displayName
                                                        )}
                                                    </span>
                                                  </p>
                                                )}
                                              </div>
                                            </Col>
                                            <Col span={6}>
                                              <div className="actionBtn">
                                                {!stockSize.isEdit && (
                                                  <GlobalSet
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "flex-end",
                                                    }}
                                                  >
                                                    <Styled>
                                                      <Tooltip
                                                        placement="bottomRight"
                                                        title={"Edit Stock"}
                                                        getPopupContainer={(
                                                          triggerNode
                                                        ) => triggerNode}
                                                      >
                                                        <Button
                                                          className="textTypeBtn "
                                                          onClick={() =>
                                                            handleEdit(index)
                                                          }
                                                          style={{ right: "8" }}
                                                        >
                                                          <Iconmoon
                                                            icon="edit"
                                                            size={16}
                                                            color="#A19F9D"
                                                          />
                                                        </Button>
                                                      </Tooltip>
                                                    </Styled>
                                                    <Styled>
                                                      <Tooltip
                                                        placement="bottomRight"
                                                        title={
                                                          stockSize.isSelected
                                                            ? "Remove Stock"
                                                            : "Add Stock"
                                                        }
                                                        getPopupContainer={(
                                                          triggerNode
                                                        ) => triggerNode}
                                                      >
                                                        <Switch
                                                          checked={
                                                            stockSize.isSelected
                                                          }
                                                          onChange={() =>
                                                            handleSwitchChange(
                                                              index
                                                            )
                                                          }
                                                          className="switch-new"
                                                          disabled={false}
                                                        />
                                                      </Tooltip>
                                                    </Styled>
                                                  </GlobalSet>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>

                                          {stockSize.isEdit && (
                                            <>
                                              <Row
                                                style={{ width: "100%", marginBottom: '10px' }}
                                                className=" "
                                              >
                                                {isExistingStock ? (
                                                  <>
                                                    <Col
                                                      style={{ paddingRight: "5px" }}
                                                      span={10}
                                                    >
                                                      <div
                                                        className="boxFormType"
                                                        style={{ marginBottom: "0" }}
                                                      >
                                                        <Form.Item
                                                          label={"Length"}
                                                          className="dBlock"
                                                          style={{ marginBottom: 0 }}
                                                        >
                                                          <Input.Group compact>
                                                            <Form.Item
                                                              name={`length${index}`}
                                                              noStyle
                                                              rules={[
                                                                {
                                                                  required: true,
                                                                  message:
                                                                    "This field is required",
                                                                },
                                                                {
                                                                  pattern: new RegExp(
                                                                    /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                                  ),
                                                                  message:
                                                                    "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                                },
                                                              ]}
                                                              initialValue={
                                                                stockSize.length
                                                              }
                                                            >
                                                              <Input
                                                                placeholder="Length"
                                                                style={{
                                                                  width:
                                                                    "calc(100% - 70px)",
                                                                  borderTopRightRadius: 0,
                                                                  borderBottomRightRadius: 0,
                                                                  cursor: "not-allowed",
                                                                }}
                                                                readOnly

                                                              />
                                                            </Form.Item>
                                                            <Form.Item
                                                              name={`length_unit${index}`}
                                                              noStyle
                                                              initialValue={
                                                                stockSize.units.length
                                                              }
                                                            >
                                                              <Select
                                                                style={{
                                                                  width: 70,
                                                                  borderTopLeftRadius: 0,
                                                                  borderBottomLeftRadius: 0,
                                                                  cursor: "not-allowed",

                                                                }}
                                                                dropdownStyle={{
                                                                  minWidth: 70,
                                                                }}
                                                                suffixIcon={
                                                                  null
                                                                }
                                                                readOnly
                                                                open={false}
                                                              >
                                                                {unitData.units_management.length.data.map(
                                                                  (length) => (
                                                                    <Option
                                                                      key={length}
                                                                    >
                                                                      {
                                                                        lengthUnit[
                                                                          length
                                                                        ].displayName
                                                                      }
                                                                    </Option>
                                                                  )
                                                                )}
                                                              </Select>
                                                            </Form.Item>
                                                          </Input.Group>
                                                        </Form.Item>
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      style={{ paddingRight: "5px" }}
                                                      span={10}
                                                    >
                                                      <div
                                                        className="boxFormType"
                                                        style={{ marginBottom: "0" }}
                                                      >
                                                        <Form.Item
                                                          label={"Width"}
                                                          className="dBlock"
                                                          style={{ marginBottom: 0 }}

                                                        >
                                                          <Input.Group compact>
                                                            <Form.Item
                                                              name={`width${index}`}
                                                              noStyle
                                                              rules={[
                                                                {
                                                                  required: true,
                                                                  message:
                                                                    "This field is required",
                                                                },
                                                                {
                                                                  pattern: new RegExp(
                                                                    /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                                  ),
                                                                  message:
                                                                    "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                                },
                                                              ]}
                                                              initialValue={
                                                                stockSize.width
                                                              }
                                                            >
                                                              <Input
                                                                placeholder="Width"
                                                                style={{
                                                                  width:
                                                                    "calc(100% - 70px)",
                                                                  borderTopRightRadius: 0,
                                                                  borderBottomRightRadius: 0,
                                                                  cursor: "not-allowed",

                                                                }}
                                                                readOnly
                                                                drop
                                                              // onChange={(e) =>
                                                              //     onAllowedQuantityChange(
                                                              //       e.target.value,
                                                              //       stockSize.size,
                                                              //       index
                                                              //     )
                                                              //   }
                                                              />
                                                            </Form.Item>
                                                            <Form.Item
                                                              name={`width_unit${index}`}
                                                              noStyle
                                                              initialValue={
                                                                stockSize.units.width
                                                              }
                                                            >
                                                              <Select
                                                                style={{
                                                                  width: 70,

                                                                  borderTopLeftRadius: 0,
                                                                  borderBottomLeftRadius: 0,
                                                                  cursor: "not-allowed",
                                                                }}
                                                                dropdownRender={null}
                                                                readOnly
                                                                dropdownStyle={{
                                                                  minWidth: 70,
                                                                }}
                                                                suffixIcon={
                                                                  null
                                                                }
                                                                open={false}
                                                              // onChange={() => {
                                                              //   form.validateFields([`allowed-quantity${index}`]);
                                                              // }}
                                                              >
                                                                {unitData.units_management.length.data.map(
                                                                  (length) => (
                                                                    <Option
                                                                      key={length}
                                                                    >
                                                                      {
                                                                        lengthUnit[
                                                                          length
                                                                        ].displayName
                                                                      }
                                                                    </Option>
                                                                  )
                                                                )}
                                                              </Select>
                                                            </Form.Item>
                                                          </Input.Group>
                                                        </Form.Item>
                                                      </div>
                                                    </Col>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Col
                                                      style={{ paddingRight: "5px" }}
                                                      span={10}
                                                    >
                                                      <div
                                                        className="boxFormType"
                                                        style={{ marginBottom: "0" }}
                                                      >
                                                        <Form.Item
                                                          label={"Length"}
                                                          className="dBlock"
                                                          style={{ marginBottom: 0 }}
                                                        >
                                                          <Input.Group compact>
                                                            <Form.Item
                                                              name={`length${index}`}
                                                              noStyle
                                                              rules={[
                                                                { required: true, message: "This field is required" },
                                                                { pattern: new RegExp(/^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/), message: "Only Numeric characters greater than zero are allowed upto 3 decimal point" },
                                                              ]}
                                                              initialValue={stockSize.length}
                                                            >
                                                              <Input
                                                                placeholder="Length"
                                                                style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                                onChange={() => {
                                                                  const length = form.getFieldValue(`length${index}`);
                                                                  const width = form.getFieldValue(`width${index}`);
                                                                  const allowedQuantity = form.getFieldValue(`allowed-quantity${index}`);
                                                                  onAllowedQuantityChange(length, width, allowedQuantity, index);
                                                                  if (isRequiredStock) {
                                                                    const lowerLimit = form.getFieldValue(`lower_limit${index}`);
                                                                    const upperLimit = form.getFieldValue(`upper_limit${index}`);
                                                                    calculateLowerLimitSheets(length, width, lowerLimit, index);
                                                                    calculateUpperLimitSheets(length, width, upperLimit, index);
                                                                  }
                                                                }}
                                                              />
                                                            </Form.Item>
                                                            <Form.Item name={`length_unit${index}`} noStyle initialValue={stockSize.units.length}>
                                                              <Select
                                                                style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                                dropdownStyle={{ minWidth: 70 }}
                                                                suffixIcon={<DownArrowDraw />}
                                                                onChange={() => {
                                                                  const length = form.getFieldValue(`length${index}`);
                                                                  const width = form.getFieldValue(`width${index}`);
                                                                  const allowedQuantity = form.getFieldValue(`allowed-quantity${index}`);
                                                                  onAllowedQuantityChange(length, width, allowedQuantity, index);
                                                                  if (isRequiredStock) {
                                                                    const lowerLimit = form.getFieldValue(`lower_limit${index}`);
                                                                    const upperLimit = form.getFieldValue(`upper_limit${index}`);
                                                                    calculateLowerLimitSheets(length, width, lowerLimit, index);
                                                                    calculateUpperLimitSheets(length, width, upperLimit, index);
                                                                  }
                                                                }}
                                                              >
                                                                {unitData.units_management.length.data.map((length) => (<Option key={length}>{lengthUnit[length].displayName}</Option>))}
                                                              </Select>
                                                            </Form.Item>
                                                          </Input.Group>
                                                        </Form.Item>
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      style={{ paddingRight: "5px" }}
                                                      span={10}
                                                    >
                                                      <div
                                                        className="boxFormType"
                                                        style={{ marginBottom: "0" }}
                                                      >
                                                        <Form.Item
                                                          label={"Width"}
                                                          className="dBlock"
                                                          style={{ marginBottom: 0 }}
                                                        >
                                                          <Input.Group compact>
                                                            <Form.Item
                                                              name={`width${index}`}
                                                              noStyle
                                                              rules={[
                                                                { required: true, message: "This field is required" },
                                                                { pattern: new RegExp(/^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/), message: "Only Numeric characters greater than zero are allowed upto 3 decimal point" },
                                                              ]}
                                                              initialValue={stockSize.width}
                                                            >
                                                              <Input
                                                                placeholder="Width"
                                                                style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                                onChange={() => {
                                                                  const length = form.getFieldValue(`length${index}`);
                                                                  const width = form.getFieldValue(`width${index}`);
                                                                  const allowedQuantity = form.getFieldValue(`allowed-quantity${index}`);
                                                                  onAllowedQuantityChange(length, width, allowedQuantity, index);
                                                                  if (isRequiredStock) {
                                                                    const lowerLimit = form.getFieldValue(`lower_limit${index}`);
                                                                    const upperLimit = form.getFieldValue(`upper_limit${index}`);
                                                                    calculateLowerLimitSheets(length, width, lowerLimit, index);
                                                                    calculateUpperLimitSheets(length, width, upperLimit, index);
                                                                  }
                                                                }}
                                                              />
                                                            </Form.Item>
                                                            <Form.Item name={`width_unit${index}`} noStyle initialValue={stockSize.units.width}>
                                                              <Select
                                                                style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                                dropdownStyle={{ minWidth: 70 }}
                                                                suffixIcon={<DownArrowDraw />}
                                                                onChange={() => {
                                                                  const length = form.getFieldValue(`length${index}`);
                                                                  const width = form.getFieldValue(`width${index}`);
                                                                  const allowedQuantity = form.getFieldValue(`allowed-quantity${index}`);
                                                                  onAllowedQuantityChange(length, width, allowedQuantity, index);
                                                                  if (isRequiredStock) {
                                                                    const lowerLimit = form.getFieldValue(`lower_limit${index}`);
                                                                    const upperLimit = form.getFieldValue(`upper_limit${index}`);
                                                                    calculateLowerLimitSheets(length, width, lowerLimit, index);
                                                                    calculateUpperLimitSheets(length, width, upperLimit, index);
                                                                  }
                                                                }}
                                                              >
                                                                {unitData.units_management.length.data.map((length) => (<Option key={length}>{lengthUnit[length].displayName}</Option>))}
                                                              </Select>
                                                            </Form.Item>
                                                          </Input.Group>
                                                        </Form.Item>
                                                      </div>
                                                    </Col>
                                                  </>
                                                )}
                                                <Col span={4}>
                                                  <div
                                                    className="boxFormType"
                                                    style={{
                                                      marginBottom: "0",
                                                      marginTop: "33px",
                                                      display: "flex",
                                                      justifyContent: "flex-end",
                                                    }}
                                                  >
                                                    <Tooltip
                                                      title={
                                                        "Save the entered value"
                                                      }
                                                    >
                                                      <Button
                                                        key="1"
                                                        className="edit-btn"
                                                        style={{
                                                          padding: "0px",
                                                          margin: "0px",
                                                          width: "28px",
                                                          border: "none",
                                                          display: "inline-block",
                                                          marginRight: "10px",
                                                        }}
                                                        onClick={() =>
                                                          onSaveChages(index)
                                                        }
                                                      >
                                                        <Iconmoon
                                                          icon="check"
                                                          size={18}
                                                          color="#3FBD61"
                                                        />
                                                      </Button>
                                                    </Tooltip>

                                                    <Tooltip
                                                      title={"Delete the stock"}
                                                    >
                                                      <Button
                                                        key="2"
                                                        className="edit-btn"
                                                        style={{
                                                          padding: "0px",
                                                          margin: "0px",
                                                          width: "28px",
                                                          border: "none",
                                                          display: "inline-block",
                                                        }}
                                                        onClick={() =>
                                                          onDiscardChanges(index)
                                                        }
                                                      >
                                                        <Iconmoon
                                                          icon="cancel"
                                                          size={18}
                                                          color="red"
                                                        />
                                                      </Button>
                                                    </Tooltip>
                                                  </div>
                                                </Col>
                                              </Row>
                                              <Row
                                                style={{ width: "100%" }}
                                                className=" "
                                              >
                                                <Col
                                                  style={{ paddingRight: "5px" }}
                                                  span={10}
                                                >
                                                  <div
                                                    className="boxFormType"
                                                    style={{ marginBottom: "0" }}
                                                  >
                                                    <Form.Item
                                                      label={"Grain"}
                                                      className="dBlock"
                                                      name={`grain${index}`}
                                                      rules={[
                                                        { required: true, message: "This field is required" },
                                                      ]}
                                                      style={{ marginBottom: 4 }}
                                                      initialValue={
                                                        stockSize.grain
                                                      }                                                                    >
                                                      <Select
                                                        placeholder={"Select grain"}
                                                        suffixIcon={<DownArrowDraw />}
                                                      >
                                                        {grainTypeData.map((grainType) => (
                                                          <Option key={grainType.value}>{grainType.label}</Option>
                                                        ))}
                                                      </Select>
                                                    </Form.Item>
                                                  </div>
                                                </Col>
                                                <Col
                                                  style={{ paddingRight: "5px" }}
                                                  span={10}
                                                >
                                                  <div
                                                    className="boxFormType"
                                                    style={{ marginBottom: "0" }}
                                                  >
                                                    <Form.Item
                                                      label={"Allowed Limit"}
                                                      className="dBlock"
                                                      style={{ marginBottom: 0 }}
                                                      extra={
                                                        isExistingStock && (
                                                          <span
                                                            style={{
                                                              color:
                                                                "var(--para-text)",
                                                              fontSize: "12px",
                                                              fontFamily:
                                                                "var(--sf-pro-text) !important",
                                                            }}
                                                          >
                                                            Available Limit:{" "}
                                                            {stockSize.availableLimit}{" "}
                                                            {weightUnit[
                                                              stockSize.availableUnit
                                                            ]?.displayName?.toUpperCase()}
                                                          </span>
                                                        )
                                                      }
                                                    >
                                                      <Input.Group compact>
                                                        <Form.Item
                                                          name={`allowed-quantity${index}`}
                                                          noStyle
                                                          rules={[
                                                            { required: true, message: "This field is required" },
                                                            { pattern: new RegExp(/^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/), message: "Only Numeric characters greater than zero are allowed upto 3 decimal point" },
                                                            ...(isExistingStock ? [{
                                                              validator: (_, value) => {
                                                                if (conversionFactorUnitsToTonne[stockSize.units.quantity] * parseFloat(stockSize.availableLimit) < conversionFactorUnitsToTonne[form.getFieldValue(`allowed-quantity_unit${index}`)] * parseFloat(value)) {
                                                                  return Promise.reject("Allowed Qty should be less than or equal to Available Limit");
                                                                } else {
                                                                  return Promise.resolve();
                                                                }
                                                              },
                                                            }] : [])
                                                          ]}
                                                          initialValue={stockSize.allowedQuantity}
                                                        >
                                                          <Input
                                                            placeholder="Allowed Limit"
                                                            style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                            onChange={(e) => onAllowedQuantityChange(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), e.target.value, index)}
                                                          />
                                                        </Form.Item>
                                                        <Form.Item name={`allowed-quantity_unit${index}`} noStyle initialValue={stockSize.units.quantity}>
                                                          <Select
                                                            style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                            dropdownStyle={{ minWidth: 70 }}
                                                            suffixIcon={<DownArrowDraw />}
                                                            onChange={() => {
                                                              form.validateFields([`allowed-quantity${index}`]);
                                                              onAllowedQuantityChange(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), form.getFieldValue(`allowed-quantity${index}`), index)
                                                            }}
                                                          >
                                                            {unitData.units_management.weight.data.map((weight) => (<Option key={weight}>{weightUnit[weight].displayName}</Option>))}
                                                          </Select>
                                                        </Form.Item>
                                                      </Input.Group>
                                                    </Form.Item>
                                                  </div>
                                                </Col>
                                                <Col span={4}>
                                                  <div
                                                    className="boxFormType"
                                                    style={{
                                                      marginBottom: "0",
                                                      marginTop: "40px",
                                                      display: "flex",
                                                      justifyContent: "flex-start",
                                                    }}
                                                  >
                                                    <Styled style={{ display: "inline-flex" }}>
                                                      <Tooltip
                                                        placement="bottomRight"
                                                        title={
                                                          stockSize.sheets ? stockSize.sheets + ' Sheets' : '-'
                                                        }
                                                      >
                                                        <span style={{ width: "16px", height: "16px" }} className="infoIcon"></span>
                                                      </Tooltip>
                                                    </Styled>
                                                  </div>
                                                </Col>
                                              </Row>

                                              {isRequiredStock && (
                                                <Row
                                                  style={{ width: "100%", marginBottom: '20px' }}
                                                  className=" "
                                                >
                                                  <Col
                                                    style={{ paddingRight: "5px" }}
                                                    span={10}
                                                  >
                                                    <div
                                                      className="boxFormType"
                                                      style={{ marginBottom: "0" }}
                                                    >
                                                      <Form.Item
                                                        label={"Lower Limit"}
                                                        className="dBlock"
                                                        style={{ marginBottom: 0 }}
                                                      >
                                                        <Input.Group compact>
                                                          <Form.Item
                                                            name={`lower_limit${index}`}
                                                            noStyle
                                                            rules={[
                                                              { required: true, message: "This field is required" },
                                                              { pattern: new RegExp(/^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/), message: "Only Numeric characters greater than zero are allowed upto 3 decimal point" },
                                                              {
                                                                validator: (_, value) => {
                                                                  if (conversionFactorUnitsToTonne[form.getFieldValue(`allowed-quantity_unit${index}`)] * parseFloat(form.getFieldValue(`allowed-quantity${index}`)) < conversionFactorUnitsToTonne[form.getFieldValue(`lower_unit${index}`)] * parseFloat(value)) {
                                                                    return Promise.reject("Lower limit should be less than or equal to Allowed Quantity");
                                                                  } else {
                                                                    return Promise.resolve();
                                                                  }
                                                                },
                                                              },
                                                            ]}
                                                            initialValue={stockSize.weight_lb}
                                                          >
                                                            <Input
                                                              placeholder="Lower Limit"
                                                              style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                              onChange={(e) => calculateLowerLimitSheets(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), e.target.value, index)}
                                                            />
                                                          </Form.Item>
                                                          <Form.Item name={`lower_unit${index}`} noStyle initialValue={stockSize.units.weight_lb}>
                                                            <Select
                                                              style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                              suffixIcon={<DownArrowDraw />}
                                                              dropdownStyle={{ minWidth: 70 }}
                                                              onChange={() => {
                                                                if (form.getFieldValue([`lower_limit${index}`])) form.validateFields([`lower_limit${index}`]);
                                                                calculateLowerLimitSheets(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), form.getFieldValue(`lower_limit${index}`), index)
                                                              }}
                                                            >
                                                              {unitData.units_management.weight.data.map((weight) => (<Option key={weight}>{weightUnit[weight].displayName}</Option>))}
                                                            </Select>
                                                          </Form.Item>
                                                        </Input.Group>
                                                      </Form.Item>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    style={{ paddingRight: "5px" }}
                                                    span={10}
                                                  >
                                                    <div
                                                      className="boxFormType"
                                                      style={{ marginBottom: "0" }}
                                                    >
                                                      <Form.Item
                                                        label={"Upper Limit"}
                                                        className="dBlock"
                                                        style={{ marginBottom: 0 }}
                                                      >
                                                        <Input.Group compact>
                                                          <Form.Item
                                                            name={`upper_limit${index}`}
                                                            noStyle
                                                            rules={[
                                                              { required: true, message: "This field is required" },
                                                              { pattern: new RegExp(/^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/), message: "Only Numeric characters greater than zero are allowed upto 3 decimal point" },
                                                              {
                                                                validator: (_, value) => {
                                                                  if (conversionFactorUnitsToTonne[form.getFieldValue(`allowed-quantity_unit${index}`)] * parseFloat(form.getFieldValue(`allowed-quantity${index}`)) > conversionFactorUnitsToTonne[form.getFieldValue(`upper_unit${index}`)] * parseFloat(value)) {
                                                                    return Promise.reject("Upper limit should be greater than or equal to Allowed Quantity");
                                                                  } else {
                                                                    return Promise.resolve();
                                                                  }
                                                                },
                                                              },
                                                            ]}
                                                            initialValue={stockSize.weight_ub}
                                                          >
                                                            <Input
                                                              placeholder="Upper Limit"
                                                              style={{ width: "calc(100% - 70px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                                              onChange={(e) => calculateUpperLimitSheets(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), e.target.value, index)}
                                                            />
                                                          </Form.Item>
                                                          <Form.Item name={`upper_unit${index}`} noStyle initialValue={stockSize.units.weight_ub}>
                                                            <Select
                                                              style={{ width: 70, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                              dropdownStyle={{ minWidth: 70 }}
                                                              suffixIcon={<DownArrowDraw />}
                                                              onChange={() => {
                                                                if (form.getFieldValue([`upper_limit${index}`])) form.validateFields([`upper_limit${index}`]);
                                                                calculateUpperLimitSheets(form.getFieldValue(`length${index}`), form.getFieldValue(`width${index}`), form.getFieldValue(`upper_limit${index}`), index)
                                                              }}
                                                            >
                                                              {unitData.units_management.weight.data.map((weight) => (<Option key={weight}>{weightUnit[weight].displayName}</Option>))}
                                                            </Select>
                                                          </Form.Item>
                                                        </Input.Group>
                                                      </Form.Item>
                                                    </div>
                                                  </Col>
                                                  <Col span={4}>
                                                    <div
                                                      className="boxFormType"
                                                      style={{
                                                        marginBottom: "0",
                                                        marginTop: "40px",
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                      }}
                                                    >
                                                      <Styled style={{ display: "inline-flex" }}>
                                                        <Tooltip
                                                          placement="bottomRight"
                                                          title={
                                                            (stockSize.upperSheets ? `Upper: ${stockSize.upperSheets} Sheets` : 'Upper: -') +
                                                            '\n' +
                                                            (stockSize.lowerSheets ? `Lower: ${stockSize.lowerSheets} Sheets` : 'Lower: -')
                                                          }
                                                        >
                                                          <span style={{ width: "16px", height: "16px" }} className="infoIcon"></span>
                                                        </Tooltip>
                                                      </Styled>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              )}

                                              <Row
                                                style={{ width: "100%" }}
                                                className=" ">
                                                <div className="checklist-address">
                                                  <Checkbox
                                                    type="checkbox"
                                                    value={stockSize.isGrainChanged}
                                                    checked={stockSize.isGrainChanged}
                                                    onChange={(e) => changeGrain(e, index)}
                                                  >
                                                    <span
                                                      style={{
                                                        fontSize: "12px",
                                                        fontStyle: "normal",
                                                        lineHeight: "20px",
                                                        fontFamily: "var(--sf-pro-text)",
                                                        color: "var(--para-text)",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      Allow grain change
                                                    </span>
                                                  </Checkbox>
                                                </div>
                                              </Row>

                                              {isRequiredStock && (
                                                <Row
                                                  style={{ width: "100%" }}
                                                  className=" ">
                                                  <div className="checklist-address">
                                                    <Checkbox
                                                      type="checkbox"
                                                      value={stockSize.priority_stock}
                                                      checked={stockSize.priority_stock}
                                                      onChange={(e) => changePriority(e, index)}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "12px",
                                                          fontStyle: "normal",
                                                          lineHeight: "20px",
                                                          fontFamily: "var(--sf-pro-text)",
                                                          color: "var(--para-text)",
                                                          margin: "0",
                                                        }}
                                                      >
                                                        It’s a Priority Stock
                                                      </span>
                                                    </Checkbox>
                                                  </div>
                                                </Row>
                                              )}
                                            </>
                                          )}
                                          {isDynamicStock &&
                                            index == stockSizes.length - 1 && (
                                              <GlobalSet
                                                style={{
                                                  marginTop: "20px",
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                  gap: "16px",
                                                }}
                                              >
                                                <Button
                                                  className="textTypeBtn textBtnIcon"
                                                  style={{
                                                    marginLeft: "0",
                                                    background: "none",
                                                  }}
                                                  onClick={onAddStock}
                                                >
                                                  <Iconmoon
                                                    icon="addcircle"
                                                    size={14}
                                                    color="#EA655B"
                                                  />
                                                  Add new sheet stock
                                                </Button>
                                                <Button
                                                  className="textTypeBtn textBtnIcon"
                                                  style={{
                                                    marginLeft: "0",
                                                    background: "none",
                                                  }}
                                                  onClick={onAddRequiredStock}
                                                >
                                                  <Iconmoon
                                                    icon="addcircle"
                                                    size={14}
                                                    color="#EA655B"
                                                  />
                                                  Add required sheet stock
                                                </Button>
                                              </GlobalSet>
                                            )}
                                        </Row>
                                      );
                                    })}
                                    {isDynamicStock && !stockSizes.length && (
                                      <GlobalSet
                                        style={{
                                          marginTop: "20px",
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "16px",
                                          justifyContent: "flex-start",
                                        }}
                                      >
                                        <Button
                                          className="textTypeBtn textBtnIcon"
                                          style={{
                                            marginLeft: "0",
                                            background: "none",
                                          }}
                                          onClick={onAddStock}
                                        >
                                          <Iconmoon
                                            icon="addcircle"
                                            size={14}
                                            color="#EA655B"
                                          />
                                          Add new sheet stock
                                        </Button>
                                        <Button
                                          className="textTypeBtn textBtnIcon"
                                          style={{
                                            marginLeft: "0",
                                            background: "none",
                                          }}
                                          onClick={onAddRequiredStock}
                                        >
                                          <Iconmoon
                                            icon="addcircle"
                                            size={14}
                                            color="#EA655B"
                                          />
                                          Add required sheet stock
                                        </Button>
                                      </GlobalSet>
                                    )}
                                  </>
                                </Col>
                              </Row>
                            </PaperBlockList>
                          </Col>
                        </Row>
                      </div>
                      {/* <div className="groupDetailWrap">
                      <Row gutter={[16, 16]} className="groupForm">
                        <Col span={10}>
                          <div
                            className="boxFieldTitle"
                            style={{ marginTop: "20px" }}
                          >
                            <label>Select Run Type</label>
                            <p>
                              Select if you would like to include specific sizes
                              quantity or let the system decide the optimum size
                              and quantity
                            </p>
                          </div>
                        </Col>
                        <Col span={14}>
                          <div
                            className="boxFormType switchRadio extraWidth"
                            style={{
                              justifyContent: "flex-start",
                              display: "flex",
                              marginTop: "20px",
                              marginLeft: "5%",
                            }}
                          >
                            <Form.Item
                              name="status"
                              className=""
                              initialValue={
                                createNewSolutionFormValuesForSizes?.status
                                  ? createNewSolutionFormValuesForSizes?.status
                                  : "selectedSizes"
                              }
                            >
                              <Radio.Group
                                options={runTypes}
                                onChange={handleRunTypeChange}
                                optionType="button"
                                buttonStyle="solid"
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="italicsTitleWithText"
                            style={{
                              justifyContent: "flex-start",
                              display: "flex",
                              marginLeft: "5%",
                            }}
                          >
                            <p>
                              You can select the size and maximum allowed
                              quantity to process
                            </p>
                          </div>
                        </Col>
                      </Row>

                      <Row gutter={[16, 16]} className="groupForm">
                        <Col span={10}>
                          <div
                            className="boxFieldTitle"
                            style={{ marginTop: "20px" }}
                          >
                            <label>Select Stock Sizes</label>
                            <p>
                              Select the sizes and quantity to process with
                              orders
                            </p>
                          </div>
                        </Col>
                        <Col span={14}>
                          {stockSizes.map((stockSize, index) => {
                            return (
                              <Row gutter={[16, 16]} className="centerAlign">
                                <Col span={18}>
                                <div className="boxFieldTitle">
                                    <label>{stockSize.stockSize + " " + (lengthUnit[stockSize.units.width].displayName).toUpperCase() + (stockSize.stockDefaultSize ? ( ' ( ' + stockSize.stockDefaultSize + ' )'):'')}</label>
                                    <p>
                                      Available Limit :{" "}
                                      {stockSize.availableLimit + " " +  capitalize(weightUnit[stockSize.units.quantity].displayName)+ (stockSize.availableDefaultLimit ? ( ' ( ' + stockSize.availableDefaultLimit + ' )'):'')}
                                    </p>
                                  </div>
                                </Col>
                                <Col span={6}>
                                  <div className="boxFormType">
                                    <GlobalSet>
                                      <Styled>
                                        <Tooltip
                                          placement="bottomRight"
                                          title={
                                            stockSize.isSelected
                                              ? "Remove Stock"
                                              : "Add Stock"
                                          }
                                          getPopupContainer={(triggerNode) =>
                                            triggerNode
                                          }
                                        >
                                          <Switch
                                            checked={stockSize.isSelected}
                                            onChange={() =>
                                              handleSwitchChange(index)
                                            }
                                            className="switch-new"
                                            disabled={false}
                                          />
                                        </Tooltip>
                                      </Styled>
                                    </GlobalSet>
                                  </div>
                                </Col>
                                {stockSize.isSelected && (
                                  <div
                                    className="boxFormType switchRadio extraWidth"
                                    style={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <div className="boxFormType" style={{alignSelf: "flex-start",width:'117px'}}>
                                    <p
                                        style={{
                                          marginLeft: "3px",
                                        }}
                                      >
                                        Rotation
                                      </p>
                                      <Form.Item
                                        name={`rotated${index}`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                        ]}
                                        initialValue={
                                          "Enabled"
                                        }
                                        className="dBlock"
                                        style={{ marginLeft: "3px" }}
                                      >
                                        <Select
                                        defaultValue={"Enabled"}
                                          placeholder={"Select"}
                                          suffixIcon={<DownArrowDraw />}
                                          // onChange={findPlannedReels}
                                          onChange={(e) =>
                                            handleRotate(
                                            e,index  
                                            )
                                          }
                                        >
                                          {rotationData.map((rotation) => (
                                            <Option key={rotation}>
                                              {rotation}
                                            </Option>
                                          ))}
                                        </Select>{" "}
                                      </Form.Item>
                                    </div>
                                    <div className="boxFormType" style={{alignSelf: "flex-start"}}>
                                    <p style={{ marginLeft: "3px" }}>
                                        Allowed quantity {'(' + capitalize(weightUnit[stockSize.units.quantity].displayName) + ')'}
                                      </p>
                                      <Form.Item
                                        name={`allowed-quantity${index}`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only numerical values are allowed",
                                          },
                                          {
                                            validator: (_, value) => {
                                              if (
                                              parseFloat( stockSize.availableLimit ) < parseFloat( value )
                                              ) {
                                                return Promise.reject(
                                                  "Allowed Qty should be less than or equal to Available Limit"
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            },
                                          },
                                        ]}
                                        initialValue={
                                          createNewSolutionFormValuesForSizes?.selectedSizes
                                            ? (createNewSolutionFormValuesForSizes?.selectedSizes.filter(
                                                (size) =>
                                                  size.stockSizeId ==
                                                  stockSize.stockSizeId
                                              )).length > 0
                                              ? getSafeFixedValue((createNewSolutionFormValuesForSizes?.selectedSizes.filter(
                                                  (size) =>
                                                    size.stockSizeId ==
                                                    stockSize.stockSizeId
                                                ))[0]?.allowedQuantity,3)
                                              : getSafeFixedValue(stockSize.availableLimit,3)
                                            : getSafeFixedValue(stockSize.availableLimit,3)
                                        }
                                        className="dBlock"
                                        style={{ marginLeft: "3px" }}
                                      >
                                        <Input
                                          placeholder=""
                                          onChange={(e) =>
                                            onAllowedQuantityChange(
                                              stockSize.length,
                                              stockSize.width,
                                              e.target.value,
                                              index
                                            )
                                          }
                                         
                                        />
                                      </Form.Item>
                                    </div>
                                    <div className="boxFormType" style={{alignSelf: "flex-start",width:'280px'}}>
                                    <p style={{ marginLeft: "3px" }}>
                                        Sheets
                                      </p>
                                      <Form.Item
                                        name={`sheets${index}`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only numerical values are allowed",
                                          },
                                        ]}
                                        // initialValue={}
                                        className="dBlock"
                                        style={{ marginLeft: "3px" }}
                                      >
                                        <Input
                                          placeholder=""
                                          onChange={(e) =>
                                            calculatePlannedWeight(
                                              stockSize.length,
                                              stockSize.width,
                                              e.target.value,
                                              index
                                            )
                                          }
                                        />
                                      </Form.Item>
                                     </div>
                                    <div className="boxFormType" style={{alignSelf: "flex-start"}}>
                                    <p style={{ marginLeft: "3px" }}>
                                        Planned Weight {'(' + capitalize(weightUnit[stockSize.units.quantity].displayName) + ')'}
                                      </p>
                                      <Form.Item
                                        name={`planned-weight${index}`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "This field is required",
                                          },
                                          // {
                                          //   validator: (_, value) => {
                                          //     if (stockSize.availableLimit < value) {
                                          //       return Promise.reject('Planned Weight should be less than or equal to Available Limit');
                                          //     }
                                          //     else {
                                          //       return Promise.resolve();
                                          //     }
                                          //   }
                                          // }
                                        ]}
                                        // initialValue={""}
                                        className="dBlock"
                                        style={{ marginLeft: "3px" }}
                                      >
                                        <Input placeholder="" disabled 
                                       
                                        />
                                      </Form.Item>
                                      {stockSize.plannedWeightError ? (
                                        <div
                                          className="errorText"
                                          style={{
                                            color: "#ea4e2c",
                                            paddingLeft: "20px",
                                          }}
                                        >
                                          {stockSize.plannedWeightError}
                                        </div>
                                      ) : null}
                                      
                                    </div>
                                  </div>
                                )}
                              </Row>
                            );
                          })}
                        </Col>
                      </Row>
                    </div> */}
                    </>
                  </HaberForm>
                </DetailFields>
              </Panes>
              <Panes tab="Machine Details" key="2">
                <DetailFields>
                  <HaberForm>
                    <div className="groupDetailWrap">
                      <Row gutter={[24]} className="groupForm">
                        <Col span={24} className="blockBreak">
                          <PaperBlockList>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle removeStar">
                                  <label>Deckle Range</label>
                                  <p>
                                    Specify the minimum and maximum deckle
                                    length of the machine
                                  </p>
                                </div>
                              </Col>
                              <Col span={12} className="d-flex threeFields">
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="min_deckle_length"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only numerical values are allowed",
                                      },
                                    ]}
                                    initialValue={
                                      formValuesForStock?.min_deckle_length
                                    }
                                    label="Min Deckle Length"
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Min Deckle Length"
                                      onChange={() => {
                                        console.log("Something changed");
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="max_deckle_length"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only numerical values are allowed",
                                      },
                                    ]}
                                    initialValue={
                                      formValuesForStock?.max_deckle_length
                                    }
                                    label="Max Deckle Length"
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Min Deckle Length"
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  className="boxFormType unitSelect"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="deckleLengthUnit"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                    ]}
                                    label="Unit"
                                    className="dBlock"
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    >
                                      {unitData.units_management.length.data.map((deckleWidth) => (
                                        <Option key={deckleWidth}>
                                          {lengthUnit[deckleWidth].displayName}
                                        </Option>
                                      ))}
                                    </Select>
                                    {/* <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={() => {
                                      }}
                                    >
                                      {deckleWidthData.map((deckleWidth) => (
                                        <Option key={deckleWidth}>
                                          {deckleWidth}
                                        </Option>
                                      ))}
                                    </Select> */}
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </PaperBlockList>
                          <PaperBlockList>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle removeStar">
                                  <label>Edge Trim</label>
                                  <p>
                                    Specify the left and right edge trim for the
                                    machine
                                  </p>
                                </div>
                              </Col>
                              <Col span={12} className="d-flex threeFields">
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="min_width"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only numerical values are allowed",
                                      },
                                    ]}
                                    initialValue={
                                      formValuesForStock?.left_edge_trim
                                    }
                                    label="Left Trim"
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Left trim"
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="max_width"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only numerical values are allowed",
                                      },
                                    ]}
                                    initialValue={
                                      formValuesForStock?.right_edge_trim
                                    }
                                    label="Right Trim"
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Right trim"
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  className="boxFormType unitSelect"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="widthUnit"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                    ]}
                                    label="Unit"
                                    className="dBlock"
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    >
                                      {unitData.units_management.length.data.map((deckleWidth) => (
                                        <Option key={deckleWidth}>
                                          {lengthUnit[deckleWidth].displayName}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </PaperBlockList>
                          <PaperBlockList>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Effective Deckle Length</label>
                                  <p>
                                    Available deckle length to match deckle
                                    after adjusting for edge trim
                                  </p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="effective_deckle_length"
                                    className=""
                                    initialValue={
                                      formValuesForStock?.effective_deckle_length
                                    }
                                    shouldUpdate
                                  >
                                    <Input
                                      disabled
                                      placeholder="Enter Deckle Length"
                                      suffix={
                                        <label className="floating-label">
                                          {lengthUnit[deckleUnit].displayName}
                                        </label>
                                      }
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </PaperBlockList>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Maximum Number of cutters</label>
                                <p>
                                  Specify maximum number of cutters including
                                  edge cutters which can be placed on deckle
                                </p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Form.Item
                                  name="cutters"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This is a required field",
                                    },
                                    {
                                      pattern: new RegExp(/^\d+(\.\d+)?$/),
                                      message:
                                        "Only numerical values are allowed",
                                    },
                                  ]}
                                  initialValue={
                                    formValuesForStock?.maximum_cutters
                                  }
                                  className=""
                                >
                                  <Input placeholder="Maximum Number of cutters" />
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>

                          <Row className="centerAlign">
                            <Col span={12} style={{ paddingRight: "20px" }}>
                              <div className="boxFieldTitle">
                                <label>Minimum weight in combination </label>
                                <p>
                                  The minimum weight that a combination should have to qualify as a part of solution
                                </p>
                              </div>
                            </Col>
                            <Col span={12} className="d-flex">
                              <div className="boxFormType">
                                <Form.Item
                                  name="min_weight_per_partition"
                                  rules={[

                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                      message:
                                        "Upto 3 decimal point values is accepted",
                                    },
                                  ]}
                                  initialValue={
                                    formValuesForStock?.min_weight_per_partition
                                  }
                                  className=""
                                >
                                  <Input
                                  />
                                </Form.Item>

                              </div>
                              <div
                                className="boxFormType unitSelect"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  name="partitionWeightUnit"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This is a required field",
                                    },
                                  ]}
                                  initialValue={
                                    formValuesForStock?.partitionWeightUnit
                                  }
                                  className="dBlock"
                                >
                                  <Select
                                    placeholder="Unit"
                                    suffixIcon={<DownArrowDraw />}

                                  >
                                    {unitData.units_management.weight.data.map((weight) => (
                                      <Option key={weight}>
                                        {weightUnit[weight].displayName}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>

                        </Col>
                      </Row>
                    </div>
                  </HaberForm>
                </DetailFields>
              </Panes>
              <Panes tab="Orders" key="3">
                             <OrdersTable
                  ordersIdList={orderIdList}
                  // jobCardDetails={jobCardDetails}
                  unselectedOrdersList={unselectedOrders}
                  groupId={jobCardDetails?.group?.group_id}
                  //isReelChanged={isSheetReelChanged}
                  machineData={machineData}
                  jobId={jobId}
                  jobCardDetails={((solutionId == '3' || solutionId == '4') && completeJCDetails?.newlyCreatedJobCardsDetails?.[0]) ? completeJCDetails?.newlyCreatedJobCardsDetails?.[0]?.jobcard : jobCardDetails}
                  updateOrderIdList={(updatedOrderIds) => {
                    setOrderIdList(updatedOrderIds);
                    updateOrdersIdList && updateOrdersIdList(updatedOrderIds);
                  }}
                  onClickSetToleranceButton={onClickSetToleranceButton}
                  visible={toleranceModal}
                  setGlobalTolerance={setGlobalTolerance}
                  globalTolerance={globalTolerance}
                  setShowAlert={setShowAlert}
                  showAlert={showAlert}
                  setGlobalReelOD={setGlobalReelOD}
                  isJobCardReelODEditModal={false}
                  setJobCardReelODEditModal={setJobCardReelODEditModal}
                />
                            </Panes>
            </Tabs>
          </StyledTab>
        </div>
      </Form>
      {sizeErrorToastr && (
              <AlertContainer
                color="red toaster"
                icon={alertRed}
                msg={"Stock size already exist."}
              />
            )}
            {orderToastr && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={"At least one order need to exist in a solution."}
        />
      )}
    </RightLayoutContainer>
  ) : '';
};
export default CreateNewSheetSolution;
